module.exports = __webpack_public_path__ + "img/email.d5510066.svg";